// extracted by mini-css-extract-plugin
export default {"moreInfoBtn":"moreInfo_moreInfoBtn__o0Xm5","moreInfoIcon":"moreInfo_moreInfoIcon__ESW2z"};